import { z } from '@customerio/hydra-validation';

const BLANK_MESSAGE = 'This field is required.';

/** The contracts-sales request form schema. */
export const ContractsSalesSchema = z.object({
  message: z.string().trim().min(1, BLANK_MESSAGE),
  features: z.string().trim().min(1, BLANK_MESSAGE),
  replyTo: z.string().trim().min(1, 'Email address is required.').email('Enter a valid email address.'),
});

export type ContractsSalesInput = z.input<typeof ContractsSalesSchema>;
export type ContractsSalesOutput = z.output<typeof ContractsSalesSchema>;
